import React from 'react';
import { userDisplayNameQuery } from '@uplift/queries';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Typography } from '@mui/material';


export const UserName: React.VFC<{ providerId: string }> = ({ providerId }) => {
  const { data } = useSuspenseQuery(userDisplayNameQuery(providerId));

  return <>{data.fullLegalName} {data.preferredFirst ? <Typography component="span" variant="inherit" color="textSecondary" fontWeight={400}>({data.preferredFirst})</Typography> : null}</>;
};
